import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { BankingInformation } from '@ui/global-shared/model/supplier/payment.model';
import { UrlHelperService } from '@ui/global-shared/util/url-helper.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BankingInformationService {
  private http = inject(HttpClient);
  private urlHelper = inject(UrlHelperService);

  setBankingInfo(bankingInformation: BankingInformation): Observable<void> {
    return this.http.put<void>(
      this.urlHelper.prepareApiPath('supplier', 'bankinginfo'),
      bankingInformation,
    );
  }

  verifyToken(token: string): Observable<boolean> {
    return this.http
      .post<boolean>(
        this.urlHelper.prepareApiPath('banking-confirmation', token),
        {},
      )
      .pipe(
        map(() => true),
        catchError(() => of(false)),
      );
  }
}
